import { render, staticRenderFns } from "./order.vue?vue&type=template&id=3a21012c&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=3a21012c&prod&lang=less&scoped=true"
import style1 from "./order.vue?vue&type=style&index=1&id=3a21012c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21012c",
  null
  
)

export default component.exports